import React from "react";
import {Mutation, Query} from "react-apollo";
import queries from "../../queries";
import {withRouter} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import BackgroundSelector from "../BackgroundSelector";

class PageSettings extends React.Component  {

  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
    this.animationTypeRef = React.createRef();
    this.state = {
      ...(props.page ? {pageName: props.page.name, animationType: props.page.animation_type}: {})
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const prevPage = prevProps.page;
    const newPage = this.props.page;
    if (!!newPage && (!prevPage || (prevPage.name !== newPage.name))) {
      this.setState({
        pageName: newPage.name,
        animationType: newPage.animation_type,
      })
    }
  }

  render() {
    const { pageName, animationType } = this.state;
    const { page } = this.props;
    const { projectId, pageId } = this.props.match.params;

    return (
      <Mutation
        mutation={queries.pages.update}
        // By operation name: the page query also needs `screen_type_id`, which is not available here, and a
        // refetch without it is rejected by the server (400 -> "Impossible de joindre le serveur"). Apollo
        // refetches the queries already on screen with their own variables.
        refetchQueries={() => ['Page', 'Project']}
      >
        {(updatePage) => (
          <Query query={queries.projects.getWithChildren} variables={{ id: projectId }}>
            {(projectQueryResponse) => {
              if (projectQueryResponse.loading) return null;
              if (projectQueryResponse.error) return `Error!: ${projectQueryResponse.error}`;
              const {project} = projectQueryResponse.data;
              if (!project) return null;

              return (
                <form
                  className="tsk-editor-form"
                  onSubmit={(e) => {
                    e.preventDefault();
                    updatePage({ variables: { input: {
                      id: pageId,
                      name: pageName,
                      background_type: this.state.backgroundType,
                      background_image_uri: this.state.backgroundImageUri,
                      background_video_uri: this.state.backgroundVideoUri,
                      background_color: this.state.backgroundColor,
                      animation_type: animationType
                    }} });
                  }}
                >
                  <div className={'tsk-form-content'}>
                    <label htmlFor={'name'}>
                      <FormattedMessage id={'page.edition.name'} />
                    </label>
                    <input name={'name'} ref={this.inputRef} value={pageName}
                      onChange={(e) => this.setState({pageName: e.target.value})} />
                  </div>

                  <div className={'tsk-form-content'}>
                    <label htmlFor={'name'}>
                      <FormattedMessage id={'page.edition.animation_type'} />
                    </label>
                    <select onChange={(e)=>{this.setState({animationType: e.target.value})}} ref={this.animationTypeRef} value={animationType}>
                      <option value={'fade'}>
                        Fade
                      </option>
                      <option value={'zoom'}>
                        Zoom
                      </option>
                      <option value={'slide-right'}>
                        Slide right
                      </option>
                      <option value={'slide-left'}>
                        Slide left
                      </option>
                      <option value={'slide-up'}>
                        Slide up
                      </option>
                      <option value={'slide-down'}>
                        Slide down
                      </option>
                      <option value={'flip'}>
                        Flip
                      </option>
                      <option value={'blur'}>
                        Blur
                      </option>
                      <option value={'corner-scale'}>
                        Corner Scale
                      </option>
                      <option value={'magic'}>
                        Magic
                      </option>
                    </select>
                  </div>

                  <BackgroundSelector
                    value={page}
                    palette={project.color_palette}
                    onChange={(bgValues) => this.setState(bgValues)}
                  />
                  <br/>
                  <div className={'tsk-form-bottom'}>
                    <button className={'tsk-button'} type="submit">
                      <FormattedMessage id={'common.button.submit'} />
                    </button>
                  </div>
                </form>
              )
            }}
          </Query>
        )}
      </Mutation>
    )
  }
}

export default withRouter(PageSettings);
